import { render, staticRenderFns } from "./ViewShipmentsProducts.vue?vue&type=template&id=5372c1c0&lang=pug&"
import script from "./ViewShipmentsProducts.vue?vue&type=script&lang=js&"
export * from "./ViewShipmentsProducts.vue?vue&type=script&lang=js&"
import style0 from "./ViewShipmentsProducts.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports